var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.loading,
            hasData: !!_vm.managerDetails,
          },
        },
        [
          !_vm.isManagerExist && !_vm.$apollo.loading
            ? _c(
                "div",
                [
                  _c("EmptyListPlaceholder", {
                    attrs: { title: "Manager not found" },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.managerDetails.manager
                    ? _c("ManagerHeader", {
                        attrs: {
                          manager: _vm.manager,
                          createdById: _vm.manager.user.created_by,
                          managerStatusProcessing: _vm.managerStatusProcessing,
                          managerDeletionProcessing:
                            _vm.managerDeletionProcessing,
                          managerActivationAllowed:
                            _vm.managerActivationAllowed,
                          isEmailUnconfirmed: !_vm.manager.user.confirmed,
                          getRoleAdmin: _vm.getRoleAdmin,
                          currentUserId: _vm.currentUser.id,
                          managerId: _vm.manager.id,
                          managerUserId: _vm.manager.user.id,
                          managerFullName: _vm.managerFullName,
                          companyId: _vm.company.id,
                          currentUser: _vm.currentUser,
                        },
                        on: {
                          changeStatus: _vm.toggleSuspend,
                          deleteManager: _vm.toggleDelete,
                        },
                      })
                    : _vm._e(),
                  _vm.getRoleAdmin
                    ? _c(
                        "div",
                        { staticClass: "bg-white routeBlockManager mt-7" },
                        [
                          _c("TabsWithRoutes", {
                            attrs: { routeTabs: _vm.routeTabs },
                            scopedSlots: _vm._u(
                              [
                                _vm.showRequestsBubble
                                  ? {
                                      key: _vm.routes.MANAGER_REQUESTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Requests")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.requests,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.projectsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_PROJECTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Clients")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.projectsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.contractorsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_CONTRACTORS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Resources")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification:
                                                _vm.contractorsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.postingsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_JOB_POSTINGS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "mr-1.5 normal-case",
                                            },
                                            [_vm._v("Job postings")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.postingsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.documentsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_DOCUMENTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Documents")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.documentsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("TabsWithRoutes", {
                            staticClass: "bg-white routeBlockManager mt-7",
                            attrs: { routeTabs: _vm.routeTabsManager },
                            scopedSlots: _vm._u(
                              [
                                _vm.contractorsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_CONTRACTORS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Resources")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification:
                                                _vm.contractorsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.postingsNumber
                                  ? {
                                      key: _vm.routes.MANAGER_JOB_POSTINGS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "mr-1.5 normal-case",
                                            },
                                            [_vm._v("Job postings")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.postingsNumber,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                  _c("router-view", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      currentUserCompanyId: _vm.currentUser.companyId,
                      currentUserRole: _vm.currentUser.role,
                      currentUserId: _vm.currentUser.id,
                      email: _vm.manager.user.private_data.email,
                      phone: _vm.phone,
                      managerFullName: _vm.managerFullName,
                      about: _vm.profile.about,
                      jobTitle: _vm.profile.job_title,
                      skills: _vm.profile.skills,
                      managerUserId: _vm.manager.user.id,
                      managerId: _vm.manager.id,
                      companyId: _vm.company.id,
                    },
                    on: {
                      requestNumberChanged: (number) =>
                        (_vm.updatedRequestsNumber = number),
                      projectNumberChanged: (number) =>
                        (_vm.updatedProjectsNumber = number),
                      postingNumberChanged: (number) =>
                        (_vm.updatedPostingNumber = number),
                      documentNumberChanged: (number) =>
                        (_vm.updatedDocumentsNumber = number),
                      collectionUpdated: function ($event) {
                        return _vm.$apollo.queries.managerDetails.refetch()
                      },
                    },
                  }),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }